// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CountryFlagMap } from '@shared/utils/Instruments/CountryMap';
export class CountryCache {
    constructor() {
        this.CachedImages = {};
        this.flagsSprite = '';
        this.flagOnCanvasWidth = 20;
        this.flagOnCanvasHeight = 15;
        this.flagLoadPromise = null;
        this.GetFlagImage = (id) => this.CachedImages[id.toString()];
        this.fetchFlagIfNotAlready = (ID) => __awaiter(this, void 0, void 0, function* () {
            const id = ID.toString();
            if (this.CachedImages[id] != null)
                return;
            const abrv = CountryFlagMap[id];
            if (abrv == null)
                return;
            const img = new Image();
            this.CachedImages[id] = img;
            if (isNullOrUndefined(this.flagLoadPromise) && this.flagsSprite.length === 0) {
                this.flagLoadPromise = fetch('assets/flags-sprite.svg').then((response) => __awaiter(this, void 0, void 0, function* () {
                    this.flagsSprite = yield response.text();
                    this.flagLoadPromise = null;
                }));
            }
            if (this.flagLoadPromise != null) {
                yield this.flagLoadPromise;
            }
            const srcStr = this.flagsSprite;
            if (srcStr == null || srcStr.length === 0)
                return;
            const iconElement = new DOMParser().parseFromString(srcStr, 'image/svg+xml');
            const svgElement = iconElement.getElementById(abrv);
            if (svgElement == null)
                return; // flag not found
            const originalWidth = parseFloat(svgElement.getAttribute('width'));
            const originalHeight = parseFloat(svgElement.getAttribute('height'));
            const viewBox = svgElement.getAttribute('viewBox');
            const widthScaleFactor = this.flagOnCanvasWidth / originalWidth;
            const heightScaleFactor = this.flagOnCanvasHeight / originalHeight;
            if (viewBox != null) {
                svgElement.setAttribute('width', this.flagOnCanvasWidth.toString());
                svgElement.setAttribute('height', this.flagOnCanvasHeight.toString());
            }
            else {
                svgElement.setAttribute('width', (originalWidth * widthScaleFactor).toString());
                svgElement.setAttribute('height', (originalHeight * heightScaleFactor).toString());
            }
            const updatedViewBox = viewBox !== null && viewBox !== void 0 ? viewBox : `0 0 ${originalWidth} ${originalHeight}`;
            svgElement.setAttribute('viewBox', updatedViewBox);
            const rectElement = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
            rectElement.setAttribute('width', '640');
            rectElement.setAttribute('height', '470');
            rectElement.setAttribute('rx', '32');
            rectElement.setAttribute('ry', '32');
            rectElement.setAttribute('fill', 'white');
            const clipPath = svgElement.querySelector('clipPath');
            if (clipPath != null) {
                clipPath.firstChild.remove();
                clipPath.appendChild(rectElement);
            }
            const svgString = new XMLSerializer().serializeToString(svgElement).replace(/symbol/g, 'svg');
            const dataUri = `data:image/svg+xml,${encodeURIComponent(svgString)}`;
            img.src = dataUri;
        });
    }
}
